var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-button', {
    attrs: {
      "theme": _vm.theme,
      "block": _vm.block,
      "primary": _vm.primary,
      "raised": _vm.raised,
      "flat": _vm.flat,
      "type": _vm.type,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.$emit('click', $event)
      }
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5371cf30","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/baseComponents/Button/Button.vue
// module id = 816
// module chunks = 0